<h2 mat-dialog-title>Generar documento</h2>

<mat-dialog-content class="dialog-body">
  @if (loading()) {
    <div class="status">
      <mat-spinner diameter="36"></mat-spinner>
    </div>
  } @else {
    @if (error(); as err) {
      <p class="error">{{ err }}</p>
    }

    @if (templates().length > 0) {
      <app-outline-field>
        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Plantilla</mat-label>
          <mat-select
            [ngModel]="selectedTemplateId()"
            (ngModelChange)="onTemplateChange($event)"
          >
            @for (template of templates(); track template.id) {
              <mat-option [value]="template.id">{{ template.name }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
      </app-outline-field>

      @if (selectedTemplate(); as template) {
        <p class="header-note">
          @if (template.includeBusinessHeader !== false) {
            Esta plantilla incluye el encabezado del consultorio.
          } @else {
            Esta plantilla no incluye encabezado (hoja membretada).
          }
        </p>
      }

      @if (needsDoctorPicker()) {
        <app-outline-field>
          <mat-form-field appearance="outline" class="full-width">
            <mat-label>Doctor</mat-label>
            <mat-select
              [ngModel]="selectedDoctorUid()"
              (ngModelChange)="onDoctorChange($event)"
            >
              @for (doctor of doctors; track doctor.uid) {
                <mat-option [value]="doctor.uid">{{ doctor.label }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
        </app-outline-field>
        @if (missingDoctor()) {
          <p class="warning">Seleccione el doctor que aparece en el documento.</p>
        }
      }

      @if (manualFields().length > 0) {
        <h3 class="section-title">Completar al generar</h3>
        @for (field of manualFields(); track trackField($index, field)) {
          <app-outline-field>
            <mat-form-field appearance="outline" class="full-width">
              <mat-label>{{ field.label }}</mat-label>
              <textarea
                matInput
                [rows]="field.type === 'list' ? 4 : 2"
                [ngModel]="fieldValue(field.key)"
                (ngModelChange)="updateFieldValue(field.key, $event)"
              ></textarea>
              @if (field.type === 'list') {
                <mat-hint>Una entrada por línea. Agrega detalles después de “ — ”.</mat-hint>
              }
            </mat-form-field>
          </app-outline-field>
        }
      }

      @if (autoFields().length > 0) {
        <h3 class="section-title">Datos automáticos (editables)</h3>
        @for (field of autoFields(); track trackField($index, field)) {
          <app-outline-field>
            <mat-form-field appearance="outline" class="full-width">
              <mat-label>{{ field.label }}</mat-label>
              @if (field.type === 'list') {
                <textarea
                  matInput
                  rows="4"
                  [ngModel]="fieldValue(field.key)"
                  (ngModelChange)="updateFieldValue(field.key, $event)"
                ></textarea>
              } @else {
                <input
                  matInput
                  [ngModel]="fieldValue(field.key)"
                  (ngModelChange)="updateFieldValue(field.key, $event)"
                  autocomplete="off"
                />
              }
              @if (field.type === 'list') {
                <mat-hint>Una entrada por línea. Agrega detalles después de “ — ”.</mat-hint>
              }
            </mat-form-field>
          </app-outline-field>
        }
      }

      @if (missingManualLabels().length > 0) {
        <p class="warning">
          Complete: {{ missingManualLabels().join(', ') }}
        </p>
      }

      <h3 class="section-title preview-title">Vista previa</h3>
      <div class="preview">
        @for (line of previewLines(); track $index) {
          <p>{{ line }}</p>
        } @empty {
          <p class="muted">Esta plantilla no tiene contenido visible.</p>
        }
      </div>
    }
  }
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button
    mat-button
    type="button"
    (click)="dialogRef.close()"
    [disabled]="exporting() || printing()"
  >
    Cancelar
  </button>
  <button
    mat-stroked-button
    type="button"
    [disabled]="loading() || exporting() || printing() || !canExport()"
    (click)="printPdf()"
  >
    @if (printing()) {
      Abriendo…
    } @else {
      Imprimir
    }
  </button>
  <button
    mat-flat-button
    color="primary"
    type="button"
    [disabled]="loading() || exporting() || printing() || !canExport()"
    (click)="exportPdf()"
  >
    @if (exporting()) {
      Generando…
    } @else {
      Descargar PDF
    }
  </button>
</mat-dialog-actions>
